import { Route } from "react-router-dom";

import BannerManager from "pages/main/BannerManager";
import BannerEdit from "pages/main/BannerManager/BannerEdit";
import BannerRegister from "pages/main/BannerManager/BannerRegister";
import PopupManager from "pages/main/PopupManager";
import PopupRegister from "pages/main/PopupRegister";
import ScheduleManager from "pages/main/ScheduleManager";

export function getMainRoutes() {
  return (
    <Route path="/main">
      <Route path="banner" element={<BannerManager />} />
      <Route path="banner/register" element={<BannerRegister />} />
      <Route path="banner/edit/:bannerId" element={<BannerEdit />} />
      <Route path="popup" element={<PopupManager />} />
      <Route path="popup/register" element={<PopupRegister />} />
      <Route path="popup/edit/:popupId" element={<PopupRegister />} />
      <Route path="schedule" element={<ScheduleManager />} />
    </Route>
  );
}
